export default __webpack_public_path__ + "static/media/twitterIcon.a36e6e41.svg";